import React from "react";
import Select from "react-select";
// import TextEditor from "../../../feature-module/inventory/texteditor";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { Calendar, PlusCircle } from "feather-icons-react/build/IconComponents";
import PropTypes from "prop-types";
import { MinusCircle } from "react-feather";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  LIST_BRANDS,
  LIST_CUSTOMER,
  // LIST_PRODUCTS,
  LIST_WAREHOUSE,
} from "../../../apollo/queries";
import useEditSale from "../../../controllers/useEditSale";
import Dropdown from "../../../feature-module/components/Dropdown";
import ErrorMessage from "../../../feature-module/components/errorMessage";
import InputField from "../../../feature-module/components/InputField";
import { getSelectedStoreDetails } from "../../../utils/helperFunctions";
import ImageWithBasePath from "../../img/imagewithbasebath";

// const status = [
//   { value: "Pending", label: "Pending" },
//   { value: "Confirmed", label: "Confirmed" },
// ];

const EditSales = (refetch, rowData, editKey) => {

  const { values, functions, getValues, setValue } = useEditSale(
    refetch,
    rowData,
    editKey
  );

  const handleReset = () => {
    functions.onCancel();
  };

  // const handleChangeProduct = (selectedOption) => {
  //   setProductArray((prevArray) => [
  //     ...prevArray,
  //     {
  //       product_id: selectedOption.value,
  //       productName: selectedOption?.label,
  //       images: selectedOption?.images,
  //       quantity: "1",
  //       price: selectedOption.price,
  //     },
  //   ]);
  // };

  const calculateGrandTotal = (orderProducts) => {
    return orderProducts
      ?.reduce((total, product) => {
        const quantity = product.quantity || 0;
        const price = product.price || 0;
        return total + quantity * price;
      }, 0)
      .toFixed(2);
  };

  const handleChangeProduct = (selectedOption) => {
    const existingProductIndex = values?.products?.findIndex(
      (product) => product.product_id === selectedOption.value
    );

    if (existingProductIndex !== -1) {
      const updatedProducts = [...values.sale_products];
      updatedProducts[existingProductIndex].quantity += 1;
      setValue("sale_products", updatedProducts);
    } else {
      functions.appendProducts({
        product_id: selectedOption.value,
        productName: selectedOption?.label,
        images: selectedOption?.images?.[0],
        quantity: 1,
        price: selectedOption.price,
      });
    }
  };

  return (
    <div>
      {/* edit popup */}
      <div className="modal fade" id="edit-sales-new">
        <div className="modal-dialog edit-sales-modal">
          <div className="modal-content">
            <div className="page-wrapper p-0 m-0">
              <div className="content p-0">
                <div className="page-header p-4 mb-0">
                  <div className="add-item new-sale-items d-flex">
                    <div className="page-title">
                      <h4>Edit Sale</h4>
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleReset}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-lg-6 col-sm-6 col-12">
                          <Controller
                            name="customer_id"
                            control={values.control}
                            rules={{ required: "Customer is required" }}
                            render={({ field }) => (
                              <Dropdown
                                field={field}
                                query={LIST_CUSTOMER}
                                disabled
                                dataKey="listCustomer"
                                variables={{
                                  storeId: getSelectedStoreDetails("id"),
                                }}
                                label="Customer Name"
                                required={true}
                                // value={values.control}
                                placeholder="Select a Customer"
                              // onChange={handleChangeCustomer}
                              />
                            )}
                          />
                          <ErrorMessage
                            error={values.errors?.customer_id?.message}
                          />
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                          <div className="input-blocks">
                            <label>
                              Date <span>*</span>
                            </label>
                            <div className="input-groupicon calender-input mb-2">
                              <Calendar className="info-img" />
                              <Controller
                                name="sale_date"
                                control={values.control}
                                rules={{ required: "Date is required" }}
                                render={({ field }) => (
                                  <>
                                    <DatePicker
                                      {...field}
                                      required={true}
                                      name="sale_date"
                                      value={dayjs(field?.value, "YYYY-MM-DD")}
                                      onChange={(date) => {
                                        let formatted_date =
                                          dayjs(date).format("YYYY-MM-DD");
                                        field.onChange(formatted_date);
                                      }}
                                      type="date"
                                      className="filterdatepicker"
                                      dateFormat="YYYY-MM-DD"
                                      placeholder="Choose Sale Date"
                                    />
                                  </>
                                )}
                              />
                            </div>
                            <ErrorMessage
                              error={values.errors?.sale_date?.message}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                          <div className="input-blocks">
                            <Controller
                              name="reference_no"
                              control={values.control}
                              render={({ field }) => (
                                <InputField
                                  name="reference_no"
                                  label="Reference Number"
                                  type="text"
                                  placeholder="Enter Reference Number"
                                  {...field}
                                />
                              )}
                            />
                            <ErrorMessage
                              error={values.errors?.reference_no?.message}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                          <Dropdown
                            query={LIST_BRANDS}
                            variables={{
                              storeId: getSelectedStoreDetails("id"),
                            }}
                            dataKey={"listBrand"}
                            label="Brand"
                            placeholder="Select a Brand"
                            field={{ value: values?.selectedBrand?.value }}
                            onChange={functions.setSelectedBrand}
                            isClearable
                          />
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                          <Controller
                            name="warehouse_id"
                            control={values.control}
                            rules={{ required: "Warehouse is required" }}
                            render={({ field }) => (
                              <Dropdown
                                query={LIST_WAREHOUSE}
                                dataKey="listWarehouse"
                                variables={{
                                  storeId: getSelectedStoreDetails("id"),
                                }}
                                label="Warehouse"
                                required
                                disabled
                                placeholder="Select a Warehouse"
                                field={field}
                              />
                            )}
                          />
                          <ErrorMessage
                            error={values.errors?.customer_id?.message}
                          />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="mb-2">
                            <label>
                              Products
                            </label>
                            <Controller
                              name="product_id"
                              control={values.control}
                              // rules={{ required: "Product is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  classNamePrefix="react-select"
                                  className="mb-2"
                                  options={values.productsData}
                                  placeholder="Select Products"
                                  value={field?.value}
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption);
                                    handleChangeProduct(selectedOption);
                                  }}
                                />
                              )}
                            />
                            {/* <Controller
                              name="product_id"
                              control={values.control}
                              render={
                                ({ field }) => (
                                  <Select
                                    {...field}
                                    classNamePrefix="react-select"
                                    className="mb-2"
                                    options={values.productsData}
                                    placeholder="Select Products"
                                    value={field.value}
                                    onChange={(selectedOption) => {
                                      field.onChange(field?.value);
                                      handleChangeProduct(selectedOption);
                                      console.log("field", field);
                                    }}
                                  />
                                )
                              }
                            /> */}
                          </div>
                          <ErrorMessage
                            error={values.errors?.product_id?.message}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="modal-body-table">
                          <div className="table-responsive no-pagination">
                            <table className="table  datanew">
                              <thead>
                                <tr>
                                  <th className="p-4">S. No</th>
                                  <th className="p-4">Product</th>
                                  <th className="p-4">Qty</th>
                                  <th className="p-4">Unit Cost</th>
                                  <th className="p-4">Total Cost</th>
                                  <th className="p-4">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {values?.products?.length > 0 ? (
                                  <>
                                    {values.products?.map((x, i) => (
                                      <tr
                                        key={x.id}
                                        style={{ background: "#ffffff" }}
                                      >
                                        <td className="p-4">{i + 1}</td>
                                        <td className="p-4">
                                          <div className="productimgname">
                                            <Link
                                              to="#"
                                              className="product-img stock-img"
                                            >
                                              <ImageWithBasePath
                                                alt=""
                                                src={
                                                  x.images?.length > 0
                                                    ? x.images
                                                    : "assets/img/profiles/avator1.jpg"
                                                }
                                                isApiImage={
                                                  x.images?.length > 0
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </Link>
                                            <Link to="#"> {x.productName}</Link>
                                          </div>
                                        </td>
                                        <td className="p-4">
                                          <Controller
                                            name={`sale_products[${i}].quantity`}
                                            control={values.control}
                                            render={({ field }) => (
                                              <div className="product-quantity">
                                                <span
                                                  className="quantity-btn"
                                                  onClick={() => {
                                                    if (field.value > 1) {
                                                      field.onChange(
                                                        field.value - 1
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <MinusCircle />
                                                </span>
                                                <input
                                                  type="number"
                                                  className="quntity-input"
                                                  {...field}
                                                />
                                                <span
                                                  className="quantity-btn"
                                                  onClick={() => {
                                                    field.onChange(
                                                      field.value + 1
                                                    );
                                                  }}
                                                >
                                                  <PlusCircle className="plus-circle" />
                                                </span>
                                              </div>
                                            )}
                                          />
                                        </td>
                                        <td className="p-4">
                                          <Controller
                                            name={`sale_products[${i}].price`}
                                            control={values.control}
                                            render={({ field }) => (
                                              <div
                                                className="product-quantity"
                                                style={{ width: "100px" }}
                                              >
                                                <input
                                                  {...field}
                                                  style={{ width: "80px" }}
                                                  type="number"
                                                  className="quntity-input"
                                                  onChange={(e) => {
                                                    field.onChange(
                                                      e.target.value
                                                    );
                                                  }}
                                                />
                                              </div>
                                            )}
                                          />
                                        </td>
                                        {/* <td className="p-4">{x.price}</td> */}
                                        <td className="p-4">
                                          ${" "}
                                          {(
                                            values?.sale_products?.[i]
                                              ?.quantity *
                                            values?.sale_products?.[i]?.price
                                          ).toFixed(2)}
                                        </td>
                                        <td className="p-4">
                                          <div className="action-table-data">
                                            <div className="edit-delete-action">
                                              <Link
                                                className="confirm-text p-2"
                                                to="#"
                                                onClick={() =>
                                                  functions.removeProducts(i)
                                                }
                                              >
                                                <i
                                                  data-feather="trash-2"
                                                  className="feather-trash-2"
                                                ></i>
                                              </Link>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={6}
                                      className="p-4"
                                      style={{ textAlign: "center" }}
                                    >
                                      No Product
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 ms-auto">
                          <div className="total-order w-100 max-widthauto m-auto mb-4">
                            <ul>
                              <li>
                                <h4>Order Tax</h4>
                                <h5>$ {getValues("sale_tax")}</h5>
                              </li>
                              <li>
                                <h4>Discount</h4>
                                <h5>$ {getValues("discount")}</h5>
                              </li>
                              <li>
                                <h4>Shipping</h4>
                                <h5>$ {getValues("shipping")}</h5>
                              </li>
                              <li>
                                <h4>Grand Total</h4>
                                <h5>
                                  $ {calculateGrandTotal(values.sale_products)}
                                </h5>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks mb-3">
                            <Controller
                              name="sale_tax"
                              control={values.control}
                              rules={{ required: "Order Tax is required" }}
                              render={({ field }) => (
                                <InputField
                                  required={true}
                                  label="Order Tax"
                                  type="text"
                                  placeholder="Enter Order Tax"
                                  value={values.control}
                                  {...field}
                                />
                              )}
                            />
                            <ErrorMessage
                              error={values.errors?.sale_tax?.message}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks mb-3">
                            <Controller
                              name="discount"
                              control={values.control}
                              rules={{
                                required: "Discount is required",
                              }}
                              render={({ field }) => (
                                <InputField
                                  required={true}
                                  label="Discount"
                                  type="text"
                                  placeholder="Enter Discount"
                                  value={values.control}
                                  {...field}
                                />
                              )}
                            />
                            <ErrorMessage
                              error={values.errors?.discount?.message}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks mb-3">
                            <Controller
                              name="shipping"
                              control={values.control}
                              rules={{
                                required: "Shipping is required",
                              }}
                              render={({ field }) => (
                                <InputField
                                  required={true}
                                  label="Shipping"
                                  type="text"
                                  placeholder="Enter Shipping"
                                  value={values.control}
                                  {...field}
                                />
                              )}
                            />
                            <ErrorMessage
                              error={values.errors?.shipping?.message}
                            />
                          </div>
                        </div>
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks mb-3">
                            <label>
                              Status <span>*</span>
                            </label>
                            <Controller
                              name="status"
                              control={values.control}
                              rules={{ required: "Status is required" }}
                              render={({ field }) => (
                                <Select
                                  classNamePrefix="react-select"
                                  className="mb-2"
                                  options={status}
                                  placeholder="Select Status"
                                  value={status.find(
                                    (item) => item.value === field?.value
                                  )}
                                  onChange={(selectedOption) =>
                                    field.onChange(selectedOption.value)
                                  }
                                />
                              )}
                            />
                            <ErrorMessage
                              error={values.errors?.status?.message}
                            />
                          </div>
                        </div> */}
                        {/* <div className="col-lg-12">
                          <div className="input-blocks summer-description-box">
                            <label>Description</label>
                            <div id="summernote5" />
                            <TextEditor />
                          </div>
                        </div> */}
                        <div className="col-lg-12 text-end">
                          <button
                            type="button"
                            className="btn btn-cancel add-cancel me-3"
                            data-bs-dismiss="modal"
                            onClick={handleReset}
                          >
                            Cancel
                          </button>
                          <Link
                            onClick={functions.onSubmit}
                            to="#"
                            className="btn btn-submit add-sale"
                          >
                            Submit
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /edit popup */}
    </div>
  );
};

EditSales.propTypes = {
  refetch: PropTypes.object,
  rowData: PropTypes.object.isRequired,
  editKey: PropTypes.object,
};

export default EditSales;
